const metrics = {
  fullWidth: '100%',
  width25: '25%',
  width50: '50%',
  base: 10,
  baseMargin: 16,
  textBoxMargin: 50,
  baseMarginV: '0 16px',
  baseMarginH: '16px 0',
  baseBottom: '88px',
  baseMarginButton: '24px',
  baseHalf: '10.5px',
  doubleBaseMargin: '32px',
  triperBaseMargin: '70px',
  navBarBtmHeight: 56,
  statusBarHeight: 24,
  borderWidth: 1,
  borderRadius: '4pt',
  buttonRadius: 6,
  buttons: {
    widthLarge: 288,
    heightLarge: 48,
    widthMed: 136,
    widthSmall: 72,
    height: 40
  },
  icons: {
    large: 45,
    small: 20,
  },
  image: {
    shopEmp: 58
  },
  tableHeader: {
    widthAuto: 'auto',
    width120: '120px',
    width100: '100px',
    width110: '110px',
    width80: '80px',
    width85: '85px',
    width90: '90px',
    width70: '70px',
    width60: '60px',
    width75: '75px',
    width20: '20px',
    width30: '30px',
    width40: '40px',
    width50: '50px',
    width125: '125px',
    width130: '130px',
    width140: '140px',
    width150: '150px',
    width160: '160px',
    width166: '166px',
    width180: '180px',
    width200: '200px',
    width214: '214px',
    width220: '220px',
    width224: '224px',
    width230: '230px',
    width250: '250px',
    width280: '280px',
    width300: '300px',
    width325: '325px',
    width350: '350px',
    width365: '365px',
    width400: '400px',
    width420: '420px',
    width435: '435px',
    width460: '460px',
    width725: '725px',
  }
};

export default metrics;
